import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ConnectorImportAppResource from './ConnectorImportAppResource';
import TransactionImportFilterAppResource from './TransactionImportFilterAppResource';

class ConnectorImportLogAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'Connector-Import-Log';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'connectors/imports/log';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'created_at',
      'updated_at',
      'import_uuid',
      'status',
      'imported_objects_count',
      'exceptions_count',
      'filters',
      'moxi_import_uuid',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      import:  ConnectorImportAppResource,
      moxiImport:  TransactionImportFilterAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      importFilter: 'import_filter_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    // TODO: add validation rules
    return [
    ];
  }

}

export default ConnectorImportLogAppResource;
